// https://i18n.nuxtjs.org/guide/lang-switcher#dynamic-route-parameters
import type { SeoAttributesOptions } from "@nuxtjs/i18n";
import type { StringNonNullMultiLocaleField } from "~~/server/graphql/datocms/generated";

export function useDatoSlugsToI18n(allSlugLocales: StringNonNullMultiLocaleField[] | undefined) {
  if (!allSlugLocales) {
    return;
  }

  const i18nparams = allSlugLocales.reduce((acc: Record<string, unknown>, item: StringNonNullMultiLocaleField) => {
    const cult = item.locale!.replace("_", "-").toLowerCase();
    acc[cult] = {
      slug: item.value === "home" ? "" : item.value,
    };
    return acc;
  }, {});

  // not all CMS pages have translations for all locales
  // must add empty values, otherwise:
  // - we get incorrect hreflang in html and
  // - links in locale switcher

  const { locales } = useI18n();
  for (const locale of locales.value) {
    if (!i18nparams[locale.code]) {
      i18nparams[locale.code] = { slug: "" };
    }
  }

  // https://i18n.nuxtjs.org/docs/composables/use-set-i18n-params
  const setI18nParams = useSetI18nParams({
    canonicalQueries: [],
  } as SeoAttributesOptions);
  setI18nParams(i18nparams);
};
